export const FROM_ONBOARDING_QUERY_PARAM = 'from-onboarding';

const MEMBER_DASHBOARD_PATH_PATTERN = /^\/(?:[^/]+\/)?member\/dashboard\/?$/;

let initialized = false;
let transitionPending = false;

function isFromOnboardingParameter(segment: string): boolean {
  const [encodedKey] = segment.split('=', 1);

  try {
    return (
      decodeURIComponent(encodedKey.replace(/\+/g, ' ')) ===
      FROM_ONBOARDING_QUERY_PARAM
    );
  } catch {
    return false;
  }
}

function removeFromOnboardingParameter(url: URL): string {
  const remainingQuery = url.search
    .slice(1)
    .split('&')
    .filter((segment) => !isFromOnboardingParameter(segment))
    .join('&');

  return `${url.pathname}${remainingQuery ? `?${remainingQuery}` : ''}${url.hash}`;
}

export function initializeOnboardingDashboardTransition(): void {
  if (initialized || typeof window === 'undefined') {
    return;
  }
  initialized = true;

  const url = new URL(window.location.href);
  const hasTransitionMarker = url.search
    .slice(1)
    .split('&')
    .some(isFromOnboardingParameter);

  if (
    !MEMBER_DASHBOARD_PATH_PATTERN.test(url.pathname) ||
    !hasTransitionMarker
  ) {
    return;
  }

  transitionPending = true;
  window.history.replaceState(
    window.history.state,
    '',
    removeFromOnboardingParameter(url)
  );
}

export function startOnboardingDashboardTransition(): void {
  transitionPending = true;
}

export function finishOnboardingDashboardTransition(): void {
  transitionPending = false;
}

export function isOnboardingDashboardTransitionPending(): boolean {
  return transitionPending;
}

export function resetOnboardingDashboardTransitionForTests(): void {
  initialized = false;
  transitionPending = false;
}
